<div class="wms-wizard-container">
    <ul class="wms-wizard clearfix steps-{{steps?.length}}" *ngIf="show" [ngStyle]="{'height': height}">
        <li *ngFor="let step of steps; index as i;" [ngClass]="{'done' : counter > i, 'current': counter === i, 'default': counter < i}">
            <a>{{step?.labelKey ? locale[step?.labelKey] : step?.label}}
                <i class="wms wms-done-bold"></i>
            </a>
            <ng-container *ngIf="!isNativeMobileApplicationType">
                <p *ngIf="step?.label == 'Layout' && step?.liveWidgetId == 'wm-table'" class="layout-sub" [ngClass]="{'active': counter === 1 && innerSteps === 'layout'}">a. {{locale.LABEL_TABLE_LAYOUT}}</p>
                <p *ngIf="step?.label == 'Template' && step?.liveWidgetId == 'wm-list'" class="layout-sub" [ngClass]="{'active': counter === 1 && innerSteps === 'layout'}">a. {{step.id == 'cards-config' ?  locale.LABEL_CARD_LAYOUT : locale.LABEL_LIST_LAYOUT }}</p>
                <p *ngIf="step?.label == 'Layout' || step?.label == 'Template'" class="layout-sub" [ngClass]="{'active': counter === 1 && innerSteps === 'pagination'}">b. {{locale.LABEL_SELECT_PAGINATION}}</p>
           </ng-container>
        </li>
    </ul>
</div>
